import { colours } from "../../_styleguide/_colours";
import * as d3 from 'd3';
import { breakpoints } from '../../_styleguide/_breakpoints';
var ChartBarHorizonY2 = /** @class */ (function () {
    function ChartBarHorizonY2(ctrlr) {
        this.ctrlr = ctrlr;
    }
    ChartBarHorizonY2.prototype.draw = function (data) {
        this.barsUp = this.ctrlr.svg.layers.data.selectAll(".bar_up")
            .data(data.slice)
            .join("rect")
            .attr("class", "bar_up")
            .attr("fill", function (d) { return colours["yellow"][0]; });
        this.barsUpVes = this.ctrlr.svg.layers.data.selectAll(".bar_up_ves")
            .data(data.slice)
            .join("rect")
            .attr("class", "bar_up_ves")
            .attr("fill", function (d) { return colours["orange"][0]; });
        this.barsDown = this.ctrlr.svg.layers.data.selectAll(".bar_down")
            .data(data.slice)
            .join("rect")
            .attr("class", "bar_down")
            .attr("fill", function (d) { return colours["lightBlue"][0]; });
        this.barsDownVes = this.ctrlr.svg.layers.data.selectAll(".bar_down_ves")
            .data(data.slice)
            .join("rect")
            .attr("class", "bar_down_ves")
            .attr("fill", function (d) { return colours["blue"][0]; });
        this.line = this.ctrlr.svg.layers.data.selectAll("path")
            .data([data.slice])
            .join("path")
            .attr("fill", 'transparent')
            .attr("stroke", "#000")
            .attr("stroke-width", 1)
            .attr("stroke-dasharray", "4 2");
    };
    ChartBarHorizonY2.prototype.redraw = function (data) {
        var _this = this;
        var self = this;
        var middle = this.ctrlr.dimensions.height / 2;
        var line = d3.line()
            .x(function (d) { return _this.ctrlr.scales.x.scale(d[_this.ctrlr.parameters.x] - .5); })
            .y(function (d, i) {
            //  let prevValue = i > 0 ? data.slice[i - 1][this.ctrlr.parameters.y3] : 0;
            return _this.ctrlr.scales.y.scale(d[_this.ctrlr.parameters.y]);
        })
            .curve(d3.curveBasis);
        this.line
            .attr("d", line)
            .attr("pointer-events", "none");
        this.barsUp
            .attr("x", function (d) {
            return self.ctrlr.scales.x.scale(d[self.ctrlr.parameters.x]);
        })
            .attr("width", (window.innerWidth > breakpoints.sm) ? (self.ctrlr.dimensions.width / (data.slice.length - 2)) - 2 : 1)
            .attr("y", function (d) { return _this.ctrlr.scales.y2.scale(d[self.ctrlr.parameters.y2]); })
            .attr("height", function (d) {
            return self.ctrlr.scales.y2.scale(0) - self.ctrlr.scales.y2.scale(d[self.ctrlr.parameters.y2]);
        });
        this.barsUpVes
            .attr("x", function (d) {
            return self.ctrlr.scales.x.scale(d[self.ctrlr.parameters.x]);
        })
            .attr("width", (window.innerWidth > breakpoints.sm) ? (self.ctrlr.dimensions.width / (data.slice.length - 2)) - 2 : 1)
            .attr("y", function (d) { return _this.ctrlr.scales.y2.scale(d[self.ctrlr.parameters.y4]); })
            .attr("height", function (d) {
            return self.ctrlr.scales.y2.scale(0) - self.ctrlr.scales.y2.scale(d[self.ctrlr.parameters.y4]);
        });
        this.barsDown
            .attr("x", function (d) {
            return self.ctrlr.scales.x.scale(d[self.ctrlr.parameters.x]);
        })
            .attr("y", self.ctrlr.dimensions.height)
            .attr("width", (window.innerWidth > breakpoints.sm) ? (self.ctrlr.dimensions.width / (data.slice.length - 2)) - 2 : 1)
            .attr("y", function (d) { return self.ctrlr.scales.y2.scale(0); })
            .attr("height", function (d) { return self.ctrlr.scales.y2.scale(0) - self.ctrlr.scales.y2.scale(d[self.ctrlr.parameters.y3]); });
        this.barsDownVes
            .attr("x", function (d) {
            return self.ctrlr.scales.x.scale(d[self.ctrlr.parameters.x]);
        })
            .attr("y", self.ctrlr.dimensions.height)
            .attr("width", (window.innerWidth > breakpoints.sm) ? (self.ctrlr.dimensions.width / (data.slice.length - 2)) - 2 : 1)
            .attr("y", function (d) { return self.ctrlr.scales.y2.scale(0); })
            .attr("height", function (d) { return self.ctrlr.scales.y2.scale(0) - self.ctrlr.scales.y2.scale(d[self.ctrlr.parameters.y5]); });
    };
    return ChartBarHorizonY2;
}());
export default ChartBarHorizonY2;
